import SaveIcon from "@mui/icons-material/Save";
import {Button} from "@mui/material";
import builder from "xmlbuilder";
import {useFormikContext} from "formik";
import {useSelector} from "react-redux";
import { filterDetailsFromJobs, filterJobs } from "./TableSums";
import { VATs } from "../../redux/settingsSlice";
import {useMemo} from "react";

export default function GenerateXML() {
    const {values} = useFormikContext()
    const mileage = useSelector(state => state.carProps.info.mileage);
    const vin = useSelector(state => state.carProps.info.vin);
    const plate = useSelector(state => state.carProps.info.plate);
    const mileageType = useSelector(state => state.carProps.info.mileageType);
    const mergedValues = useMemo(() => {
        return {
            ...values,
            mileage,
            vin,
            plate,
            mileageType: mileageType ? mileageType : null
        };
    }, [values, mileage, mileageType, vin, plate]);


    const diffFlag = useSelector(state => state.settings.diffFlag)
    const rawJobs = useSelector(state => state.jobs.jobs);
    const jobs = filterJobs(rawJobs);
    const details = filterDetailsFromJobs(rawJobs);

    const jobsVat = useSelector(state => state.settings.vats[VATs.jobs]);
    const partsVat = useSelector(state => state.settings.vats[VATs.parts]);

    const jobsXML = [];
    const detailsXML = [];
    const tipsXML = [];
    jobs.forEach(job => {
        if (!job.detail.detailOnly && !job.repair_tips ) {
            jobsXML.push(
                {
                    // JobID: job.job_id,
                    // PartID: job.detail.part_id,
                    PartName: job.detail.part_name,
                    // OperationID: job.operation.operation_id,
                    OperationName: job.operation.operation_name,
                    HourPrice: Math.round(job.hourPrice * (diffFlag === 1 ? job.difficulty : 1) * 100) / 100,
                    Hours: Math.round(job.sdh_hour * (diffFlag === 0 ? job.difficulty : 1) * 100) / 100,
                    VAT: jobsVat.active ? jobsVat.value : 0,
                    VATType: jobsVat.active ? jobsVat.type + 1 : 0,
                }
            )
        }
        if(job.repair_tips){
            tipsXML.push(
                {
                    // JobID: job.job_id,
                    // PartID: job.detail.part_id,
                    PartName: job.detail.part_name,
                    // OperationID: job.operation.operation_id,
                    OperationName: job.operation.operation_name,
                    HourPrice: Math.round(job.hourPrice * (diffFlag === 1 ? job.difficulty : 1) * 100) / 100,
                    Hours: Math.round(job.sdh_hour * (diffFlag === 0 ? job.difficulty : 1) * 100) / 100,
                    VAT: jobsVat.active ? jobsVat.value : 0,
                    VATType: jobsVat.active ? jobsVat.type + 1 : 0,
                }
            )
        }
    });

    details.forEach(item => {
        const customVat = item.job.detail.custom_vat_value;
        const hasCustomVat = customVat !== null && customVat !== undefined; 
        const vat = hasCustomVat ? customVat : partsVat.value;

        detailsXML.push({
            // PartID: detail.part_id,
            PartName: item.job.detail.part_name,
            Price: item.job.detail.price,
            Amount: item.job.detail.amount,
            VAT: partsVat.active ? vat : 0,
            VATType: partsVat.active ? partsVat.type + 1 : 0,
        });
    });

    function generateXML() {
        let obj = {
            RepairTimes: {
                Car: {
                    Year: mergedValues.year,
                    Manufacturer: mergedValues.make.make,
                    Model: mergedValues.serie.serie,
                    Mileage:mergedValues.mileage ? `${mergedValues.mileage}` : null,
                    MileageType:mergedValues.mileageType && mergedValues.mileage ? `${mergedValues.mileageType}` : null,
                    FuelType: mergedValues.fuel ? mergedValues.fuel.fuel : null,
                    FuelName: mergedValues.fuel ? mergedValues.fuel.fuelName : null,
                    Displacement: mergedValues.displacement && mergedValues.displacement.displacement !== '-' ? mergedValues.displacement.displacement : null,
                    Plate:mergedValues.plate ? mergedValues.plate : null,
                    Vinframe:mergedValues.vin ? mergedValues.vin : null,
                    Jobs: {
                        Job: jobsXML
                    },
                    JobRecommend: {
                        Job: tipsXML
                    },
                    Parts: {
                        Part: detailsXML,
                    },
                },
            }
        };

        let xml = builder.create(obj).end({ pretty: true});
        // console.log(xml);

        let link = document.createElement('a');
        link.download = values.year + '_' +
            values.make.make + '_' +
            values.serie.serie +
            (values.fuel ?  '_' + values.fuel.fuel : '') +
            (values.displacement && values.displacement.displacement !== '-' ? '_' + Number(values.displacement.displacement).toFixed(1) : '') + '.xml';
        let blob = new Blob([xml], {type: 'application/xml'});
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
    }

    return (
        <Button variant={'outlined'}
                size={'small'}
                startIcon={<SaveIcon/>}
                onClick={generateXML}
                sx={{mt: 1}}>
            Скачать в формате XML
        </Button>
    )
}